/*
 * 地图工具组件
 * @module components/maptools/MapTools
 * @desc 用于操作地图
 * @author zhaoting
 * @date 2019年12月16日
 */
// import shp from "shpjs";
import '../../../static/sdk/ol-debug.js';
// import '../../../static/sdk/zondyClient.js';
import printJS from 'print-js';
import Vue from 'vue';
import LayerTree from '../layertree/LayerTree.vue';
import drawTool from '../drawTool/drawTool.vue';
import appConfig from 'appConfig';
import Cookies from 'js-cookie';
import exportShpAndText from './exportShpAndText.vue';
import selectArea from './selectArea.vue';
import { shpUpload, selectLike } from '@/api/index';
import axios from 'axios';
import { postToolAllCoordinates } from '@/api/CatalogSet.js';
// import 'BMapGL-draw/es/style/DrawingManager.css';
// import { DrawScene, PolygonDraw } from 'BMapGL-draw';
export default {
  name: 'MapTools',
  components: {
    LayerTree,
    drawTool,
    exportShpAndText,
    selectArea,
  },
  data() {
    return {
      layerShow: false,
      spinshow: false,
      zxDrawm: {},
      toolsData: [],
      layersData: [],
      toolShow: false,
      toolOptData: [],
      gridDraws: null,
      gridDrawLayer: null,
      toolType: {
        '1': 'fullScreen',
        '2': 'full',
        '3': 'zoomOut',
        '4': 'zoomIn',
        '5': 'draw',
        '6': 'location',
        '7': 'showlayer',
        '8': 'drawtool',
        '9': 'cleardraw',
        '10': 'area',
        '11': 'distance',
        '12': 'print',
        '13': 'distinguish',
      },
      distinguish: false,
      fullscr: document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen,
      configMap: {},
      layersModal: false,
      drawsModal: false,
      initdrawsModal: false,
      uploadHeader: { accessToken: Cookies.get('accessToken') },
      uploadModal: false,
      uploadData: {
        layerName: '',
        description: '',
        type: 'dwg',
        saveLayer: 'true',
        inputCoordinate: 'EPSG:4490',
      },
      userinfo: null,
      xbootConfig: '/zituSpace',
      drawingManager: null,
      xbootshpConfig: '/zituSpace',
      flagExportShpAndText: false,
      flagSelectArea: false,
      selectAreaDataArr: [],
      // 右下角加的图层的名字
      nowTopLayerName: '',
      file: '',
      // 输入坐标系存储坐标的数组
      inputCoordinateArr: [],
      dwgFileList: [],
      coordinateArr: [],
      drawGrid: {
        geometry: '',
        polygonWKT: '',
        polygonJson: [],
        feature: null,
      },
      currentGeometryType: 'POLYGON',
      uploadDataShpANDTxt: {
        layerName: '',
        type: '',
        description: '',
        geometry: '',
        remark: '',
        sortOrder: null,
      },
      flagShowTools: true,
      overlay: null,
    };
  },
  computed: {
    isFullScreen() {
      return this.fullscr;
    },
  },
  props: {
    value1: {
      type: Number,
      default: 20,
    },
  },
  watch: {},
  //监测渲染变化，从而获取全屏状态值
  mounted() {
    this.$nextTick(() => {
      // 实例化鼠标绘制工具
      this.drawingManager = new BMapGLLib.DrawingManager(window.BDMap, {
        enableSorption: true, // 是否开启边界吸附功能
        drawingMode: 'polygon',
        polygonOptions: {
          strokeColor: '#e38932', // 边线颜色
          fillColor: '#e38932', // 填充颜色。当参数为空时，圆形没有填充颜色
          strokeWeight: 1, // 边线宽度，以像素为单位
          strokeOpacity: 1, // 边线透明度，取值范围0-1
          fillOpacity: 0.2, // 填充透明度，取值范围0-1
        }, // 多边形的样式
      });
    });
    this.userinfo = JSON.parse(localStorage.getItem('userInfo'));
    window.onresize = () => {
      this.fullscr =
        document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen;
    };
    let gongju = document.querySelector('.tool-construct').getBoundingClientRect();
    document.querySelector('.tool_opt').style.left = gongju.left - 75 + 'px';
    // 左边菜单抛事件
    this.$bus.off('sendMessageMapTool');
    this.$bus.on('sendMessageMapTool', data => {
      this.flagShowTools = data;
      console.log(data);
    });
  },
  created() {
    this.xbootConfig = this.publicMethod.xbootConfig;
    this.xbootshpConfig = this.publicMethod.baseXbootShp;
    this.toolsData = appConfig.map.customTools.tool;
    var topd = this.toolsData.filter(item => item.id == 'mapTools');
    if (topd) {
      this.toolOptData = topd[0].childtool;
    }
    this.configMap = appConfig.map;
    // this.requestAllCoordinate();
  },
  methods: {
    // 请求所有坐标系的函数
    async requestAllCoordinate() {
      let res = await postToolAllCoordinates();
      if (res.code == 200) {
        this.coordinateArr = res.result;
        this.inputCoordinateArr = this.inputCoordinateArr.concat(this.coordinateArr);
        this.inputCoordinateArr.push('EPSG:4490');
        // this.outputCoordinateArr = this.outputCoordinateArr.concat(this.coordinateArr);
      } else {
        this.coordinateArr = [];
        this.$Message.warning('获取坐标系失败，暂时无法进行投影转换');
      }
    },
    // 输入坐标系搜索框模糊查询
    async remoteInputLike(query) {
      let params = {
        name: '',
      };
      if (query != '') {
        params.name = query;
        let likeRes = await selectLike(params);
        if (likeRes.code == 200) {
          this.inputCoordinateArr = likeRes.result;
        } else {
          this.$Message.warning('没有找到指定坐标系');
        }
      }
    },
    uploadModalSubmit() {
      if (!this.file) {
        this.$Message.info('请先上传文件!');
        return;
      }
      let formData = new FormData();
      formData.append('type', this.uploadData.type);
      formData.append('description', this.uploadData.description);
      formData.append('saveLayer', this.uploadData.saveLayer);
      formData.append('layerName', this.uploadData.layerName);
      formData.append('inputCoordinate', this.uploadData.inputCoordinate);
      formData.append('file', this.file);
      let accessToken = Cookies.get('accessToken');
      let res = axios.post(`${this.xbootshpConfig}/dwgToShp/uploadDwg`, formData, {
        transformRequest: function(data, headers) {
          headers.accessToken = accessToken;
          delete headers.post['Content-Type'];
          return data;
        },
      });
    },
    // 上传图层文件之前会触发的函数
    beforeupload(res) {
      let dwgFileList = [];
      this.file = res;
      dwgFileList.push({ name: res.name });
      this.dwgFileList = dwgFileList;
      console.log(dwgFileList);
    },
    layerListChange(layerListData) {
      if (layerListData.length > 0) {
        this.nowTopLayerName = layerListData[0].title;
      } else {
        this.nowTopLayerName = '暂无图层';
      }
    },
    hidelayers() {
      this.layersModal = false;
    },
    closeDraw() {
      this.uploadModal = false;
      this.olmap.drawOpt = false;
    },
    //工具栏中事件选择
    clickTool(item) {
      if (item.name == '增大') {
        let zoom = window.BDMap.getZoom();
        window.BDMap.setZoom(zoom + 1);
      }
      if (item.name == '缩小') {
        let zoom = window.BDMap.getZoom();
        window.BDMap.setZoom(zoom - 1);
      }
      if (item.name == '绘制') {
        if (this.overlay) {
          window.BDMap.removeOverlay(this.overlay);
        }
        var overlaycomplete = e => {
          let arr = [];
          this.overlay = e.overlay;
          e.overlay.getPath().forEach(item => {
            arr.push(`${item.lng} ${item.lat}`);
          });
          this.$bus.$emit('drawPolygon', `POLYGON((${arr.join(',')}))`);
        };
        this.drawingManager.open();
        this.drawingManager.addEventListener('overlaycomplete', overlaycomplete);
        // const scene = new DrawScene(window.BDMap, {
        //   noLimit: true,
        // });
        // const polygon = new PolygonDraw(scene, {
        //   hideTip: true, // 隐藏绘制提示
        //   isOpen: true,
        //   labelOptions: {
        //     borderRadius: '2px',
        //     background: '#b5d3fb',
        //     border: '1px solid #b5d3fb',
        //     color: '#333',
        //     fontSize: '12px',
        //     letterSpacing: '0',
        //     padding: '5px',
        //   },
        //   baseOpts: {
        //     fillColor: '#fff',
        //     strokeWeight: 5,
        //     strokeOpacity: 1,
        //     fillOpacity: 0.2,
        //   }
        // });
      }
      if (item.name == '清除') {
        window.BDMap.removeOverlay(this.overlay);
        this.$bus.$emit('drawPolygon', '');
      }
      // if (item.name == '工具') {
      //   this.toolShow = true;
      //   this.cleardraw();
      // } else {
      //   this.toolShow = false;
      //   if (item.name == '绘制') {
      //     this.drawsModal = true;
      //     this.initdrawsModal = true;
      //     this.cleardraw();
      //   } else if (item.name == '打印') {
      //     // const style = '@page { margin:500px } @media print { }'// 自定义样式
      //     //printJS('images/PrintJS.jpg', 'image')
      //     printJS({
      //       printable: 'basemap', // 要打印内容的id
      //       type: 'html', // 打印类型 pdf, html, image, json and raw-html
      //       // style: style,
      //       scanStyles: false,
      //       // documentTitle: "aaa"
      //     });
      //   } else if (item.name == '截图') {
      //     this.olmap.once('postcompose', function(event) {
      //       var canvas = event.context.canvas;
      //       if (navigator.msSaveBlob) {
      //         navigator.msSaveBlob(canvas.msToBlob(), 'map.png');
      //       } else {
      //         canvas.toBlob(function(blob) {
      //           saveAs(blob, 'map.png');
      //         });
      //       }
      //     });
      //     this.olmap.renderSync();
      //   } else if (item.name == '属性') {
      //     // 识别是否开启
      //     if (this.distinguish && this.olmap.distinguish) {
      //       $('.distin .icon').css(
      //         'background-image',
      //         'url(../../../static/img/tool/distin_un.png)'
      //       );
      //       $('.distin .li-span').css('color', '#333');
      //       this.distinguish = false;
      //       this.olmap.distinguish = false;
      //       // 绘制的图层以及底部的数据
      //       this.$bus.emit('closeDistin', null);
      //       this.olmap.distinLayer = null;
      //     } else {
      //       // 绑定第一条图层进行查询
      //       if (this.olmap.selecLayers && this.olmap.selecLayers.length > 0) {
      //         this.olmap.distinLayer = this.olmap.selecLayers[0];
      //         $('.distin .icon').css(
      //           'background-image',
      //           'url(../../../static/img/tool/distin.png)'
      //         );
      //         $('.distin .li-span').css('color', 'rgba(51, 136, 255, 0.8)');
      //         this.distinguish = true;
      //         this.olmap.distinguish = true;
      //         this.$bus.emit('closebottom', null);
      //       } else {
      //         this.olmap.distinLayer = null;
      //         this.$Message.info('请先勾选图层树节点！');
      //       }
      //     }
      //   } else if (item.name == '导入') {
      //     this.uploadModal = true;
      //   } else if (item.name == '导出') {
      //     this.flagExportShpAndText = true;
      //   } else if (item.name == '行政区') {
      //     this.flagSelectArea = true;
      //   } else {
      //     this[this.toolType[item.id]](item);
      //   }
      //   //this.$print(this.$parent.$refs.olmap) // 使用
      // }
    },
    //关闭导出的弹框
    closeLayerShp() {
      this.flagExportShpAndText = false;
    },
    closeLayerArea() {
      this.flagSelectArea = false;
    },
    selectAreaData(data) {
      this.selectAreaDataArr = data;
    },
    /**
     * 展示图层-回调
     * @param {Boolean} [payload] -返回显示状态
     */
    parentFn(payload) {
      //this.message = payload;
      this.layerShow = payload;
    },
    // 影藏图层框
    hidelayer() {
      this.layerShow = false;
    },
    // 展示图层
    showlayer() {
      this.layersModal = true;
      this.layerShow = true;
    },
    /**
     * @description 清除绘制结果
     */
    cleardraw() {
      // 清除行政区划边界的数据
      if (this.selectAreaDataArr.length > 0) {
        this.selectAreaDataArr.forEach(item => {
          this.olmap.removeLayer(item);
        });
        this.selectAreaDataArr = [];
      }
      if (this.$refs.selectArea) {
        this.$refs.selectArea.activeIndex = -1;
        this.$refs.selectArea.activeIndexC = -1;
        this.$refs.selectArea.activeIndexQ = -1;
        var paramCode = {
          activeIndex: 0,
          activeIndexC: -1,
          activeIndexQ: -1,
        };
        this.$store.commit('setAreaCode', paramCode);
      }
      // this.olmap.clearLayer("draw_tool");
      if (this.olmap.zxDrawm) {
        this.olmap.removeInteraction(this.olmap.zxDrawm);
      }
      this.olmap.drawOpt = false;
      // 绘制图层移除
      if (this.olmap.gridDrawLayer) {
        this.olmap.gridDrawLayer.getSource().clear();
      }

      // 清除弹框
      var pops = this.olmap.zxPops;
      if (pops && pops.length > 0) {
        for (var i = 0; i < pops.length; i++) {
          pops[i].close();
        }
      }

      this.olmap.zxQueryLayer.getSource().clear(); //查询结果清除
      // 绘制结果清除
      if (this.olmap.zxMeasureTooltip) this.olmap.removeOverlay(this.olmap.zxMeasureTooltip);
      if (this.olmap.zxHelpTooltip) this.olmap.removeOverlay(this.olmap.zxHelpTooltip);
      if (this.olmap.zxMeasureTipStack) {
        for (var i = 0; i < this.olmap.zxMeasureTipStack.length; i++)
          this.olmap.removeOverlay(this.olmap.zxMeasureTipStack[i]);
      }
      if (this.olmap.zxDrawLayer) {
        this.olmap.zxDrawLayer.getSource().clear();
      }

      //清除地标产品
      let that = this;
      var layers = this.olmap.getLayers();
      var arrs = [];
      //如果图层存在，则移除
      layers.forEach(function(sublayer, i) {
        console.log(sublayer.getProperties().id);
        if (that.markerData) {
          if (sublayer != undefined && sublayer.getProperties().id === that.markerData.id) {
            //that.olmap.removeLayer(sublayer);
            arrs.push(sublayer);
          }
        } else if (
          sublayer != undefined &&
          (sublayer.getProperties().id === '__querysqew' ||
            sublayer.getProperties().id.indexOf('_shpdwg') >= 0 ||
            sublayer.getProperties().id === 'query_draw')
        ) {
          sublayer.getSource().clear();
          arrs.push(sublayer);
          //that.olmap.removeLayer(sublayer);
        }
      });

      for (var i = 0; i < arrs.length; i++) {
        this.olmap.removeLayer(arrs[i]);
      }
    },
    upShow: function(item) {
      if (item.name == '工具') {
        this.toolShow = true;
      } else {
        this.toolShow = false;
      }
    },
    upShowList: function() {
      this.toolShow = true;
    },
    menuShow() {
      this.toolShow = false;
    },
    //工具栏中工具事件选择
    clickOptTool(item) {
      //this[this.toolType[item.id]](item);
      if (item.name === '全屏') {
        this.fullScreen(item);
      }
      //  else if (item.title === '取消全屏') {
      //   this.unfullScreen(item);
      // }
      else if (item.name === '放大') {
        this.zoomOut();
      } else if (item.name === '缩小') {
        this.zoomIn();
      } else if (item.name === '重置') {
        this.olmap.getView().setZoom(this.configMap.zoom);
        var longitude = this.configMap.center.lng;
        var latitude = this.configMap.center.lat;
        this.olmap.getView().setCenter([parseFloat(longitude), parseFloat(latitude)]);
        //  this.olmap.getView().setCenter(this.$olmap.proj.transform(this.configMap.center, 'EPSG:4326', 'EPSG:3857'));
      } else if (item.name === '测面') {
        this.startMeasure('Polygon');
      } else if (item.name === '测距') {
        this.startMeasure('LineString');
      } else if (item.name == '截图') {
        this.olmap.once('postcompose', function(event) {
          var canvas = event.context.canvas;
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(canvas.msToBlob(), 'map.png');
          } else {
            canvas.toBlob(function(blob) {
              saveAs(blob, 'map.png');
            });
          }
        });
        this.olmap.renderSync();
      } else if (item.name == '识别') {
        // 识别是否开启
        if (this.distinguish && this.olmap.distinguish) {
          this.distinguish = false;
          this.olmap.distinguish = false;
          // 清除绘制的图层以及底部的数据
          this.$bus.emit('closeDistin', null);
          this.olmap.distinLayer = null;
        } else {
          this.distinguish = true;
          this.olmap.distinguish = true;
          this.$bus.emit('closebottom', null);
          // 绑定第一条图层进行查询
          if (this.olmap.selecLayers && this.olmap.selecLayers.length > 0) {
            this.olmap.distinLayer = this.olmap.selecLayers[0];
          } else {
            this.olmap.distinLayer = null;
          }
        }
      }
    },
    /**
     * @description 再次绘制前清除
     * @param {object} [map] -地图组件
     */
    clearMap(map) {
      if (map.zxDrawm) {
        map.removeInteraction(map.zxDrawm);
      }
      map.zxDrawLayer.getSource().clear();
    },

    startMeasure(type) {
      this.olmap.drawOpt = true;
      var map = this.olmap;
      let that = this;
      if (this.olmap.zxDrawm) this.olmap.removeInteraction(map.zxDrawm);
      if (this.olmap.zxMeasureTooltip) this.olmap.removeOverlay(this.olmap.zxMeasureTooltip);
      if (this.olmap.zxHelpTooltip) this.olmap.removeOverlay(map.zxHelpTooltip);
      if (this.olmap.zxMeasureTipStack) {
        for (var i = 0; i < this.olmap.zxMeasureTipStack.length; i++)
          this.olmap.removeOverlay(this.olmap.zxMeasureTipStack[i]);
      }
      this.olmap.zxDrawLayer.getSource().clear();
      this.olmap.zxDrawm = new this.$olmap.interaction.Draw({
        type: type,
        source: this.olmap.zxDrawLayer.getSource(),
        style: new this.$olmap.style.Style({
          //绘制几何图形的样式
          fill: new this.$olmap.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new this.$olmap.style.Stroke({
            color: 'rgba(255, 0, 0, 0.5)',
            width: 2,
          }),
          image: new this.$olmap.style.Circle({
            radius: 4,
            stroke: new this.$olmap.style.Stroke({
              color: 'rgba(255, 0, 0, 0.7)',
            }),
            fill: new this.$olmap.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)',
            }),
          }),
        }),
      });
      this.olmap.addInteraction(this.olmap.zxDrawm);
      var listener, sketch;
      this.olmap.zxDrawm.on(
        'drawstart',
        function(evt) {
          // zx.map.zxState = 1;
          sketch = evt.feature; //绘制的要素
          var tooltipCoord = evt.coordinate; // 绘制的坐标
          //绑定change事件，根据绘制几何类型得到测量长度值或面积值，并将其设置到测量工具提示框中显示
          listener = sketch.getGeometry().on('change', function(evt) {
            var geom = evt.target; //绘制几何要素
            var output;
            if (geom instanceof that.$olmap.geom.Polygon) {
              output = formatArea(/** @type {ol.geom.Polygon} */ (geom)); //面积值
              tooltipCoord = geom.getInteriorPoint().getCoordinates(); //坐标
            } else if (geom instanceof that.$olmap.geom.LineString) {
              output = formatLength(/** @type {ol.geom.LineString} */ (geom)); //长度值
              tooltipCoord = geom.getLastCoordinate(); //坐标
            }
            that.olmap.zxMeasureTooltipElement.innerHTML = output; //将测量值设置到测量工具提示框中显示
            that.olmap.zxMeasureTooltip.setPosition(tooltipCoord); //设置测量工具提示框的显示位置
          });
          createHelpTooltip();
          createMeasureTooltip();
          that.olmap.on('pointermove', pointerMoveHandler); //地图容器绑定鼠标移动事件，动态显示帮助提示框内容
        },
        this
      );
      //绑定交互绘制工具结束绘制的事件
      this.olmap.zxDrawm.on(
        'drawend',
        function(evt) {
          // zx.map.zxState = 0;
          that.olmap.zxMeasureTooltipElement.className = 'tooltip tooltip-static'; //设置测量提示框的样式
          that.olmap.zxMeasureTooltip.setOffset([0, -7]);
          // unset sketch
          sketch = null; //置空当前绘制的要素对象
          // unset tooltip so that a new one can be created
          that.olmap.zxMeasureTooltipElement = null; //置空测量工具提示框对象
          that.olmap.zxMeasureTipStack = that.olmap.zxMeasureTipStack || [];
          that.olmap.zxMeasureTipStack.push(that.olmap.zxMeasureTooltip);
          createMeasureTooltip(); //重新创建一个测试工具提示框显示结果
          that.$olmap.Observable.unByKey(listener);
        },
        this
      );
      //地图绑定鼠标移出事件，鼠标移出时为帮助提示框设置隐藏样式
      $(that.olmap.getViewport()).on('mouseout', function() {
        $(that.olmap.zxHelpTooltipElement).addClass('hidden');
      });
      /**
       *创建一个新的帮助提示框（tooltip）
       */
      function createHelpTooltip() {
        if (that.olmap.zxHelpTooltipElement) {
          that.olmap.zxHelpTooltipElement.parentNode.removeChild(that.olmap.zxHelpTooltipElement);
        }
        that.olmap.zxHelpTooltipElement = document.createElement('div');
        that.olmap.zxHelpTooltipElement.className = 'tooltip hidden';
        that.olmap.zxHelpTooltip = new that.$olmap.Overlay({
          element: that.olmap.zxHelpTooltipElement,
          offset: [15, 0],
          positioning: 'center-left',
        });
        that.olmap.addOverlay(that.olmap.zxHelpTooltip);
      }
      /**
       *创建一个新的测量工具提示框（tooltip）
       */
      function createMeasureTooltip() {
        if (that.olmap.zxMeasureTooltipElement) {
          that.olmap.zxMeasureTooltipElement.parentNode.removeChild(
            that.olmap.zxMeasureTooltipElement
          );
        }
        that.olmap.zxMeasureTooltipElement = document.createElement('div');
        that.olmap.zxMeasureTooltipElement.className = 'tooltip tooltip-measure';
        that.olmap.zxMeasureTooltip = new that.$olmap.Overlay({
          element: that.olmap.zxMeasureTooltipElement,
          offset: [0, -50],
          positioning: 'center-left',
        });
        that.olmap.addOverlay(that.olmap.zxMeasureTooltip);
      }

      /**
       * 测量长度输出
       * @param {ol.geom.LineString} line
       * @return {string}
       */
      var formatLength = function(line) {
        var length;
        length = line.getLength(); //直接得到线的长度
        var output;
        // add by  qqjuanqq  2021-08-11
        if (appConfig.map.proj == 'EPSG:4490' || appConfig.map.proj == 'EPSG:4326') {
          length = Number(length) * 111000;
        }
        if (length > 100) {
          output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km'; //换算成KM单位
        } else {
          output = Math.round(length * 100) / 100 + ' ' + 'm'; //m为单位
        }
        return output; //返回线的长度
      };
      /**
       * 测量面积输出
       * @param {ol.geom.Polygon} polygon
       * @return {string}
       */
      var formatArea = function(polygon) {
        var area;
        area = polygon.getArea(); //直接获取多边形的面积
        var output;
        // add by  qqjuanqq  2021-08-11
        if (appConfig.map.proj == 'EPSG:4490' || appConfig.map.proj == 'EPSG:4326') {
          area = Number(area) * 111000 * 111000;
        }
        if (area > 10000) {
          output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'; //换算成KM单位
        } else {
          output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'; //m为单位
        }
        return output; //返回多边形的面积
      };
      /**
       *  当用户正在绘制多边形时的提示信息文本
       * @type {string}
       */
      var continuePolygonMsg = '单击继续绘制多边形';
      /**
       * 当用户正在绘制线时的提示信息文本
       * @type {string}
       */
      var continueLineMsg = '单击继续绘制线';

      /**
       * 鼠标移动事件处理函数
       * @param {ol.MapBrowserEvent} evt
       */
      function pointerMoveHandler(evt) {
        if (evt.dragging) {
          return;
        }
        /** @type {string} */
        var helpMsg = '开始绘制'; //当前默认提示信息
        //判断绘制几何类型设置相应的帮助提示信息
        if (sketch) {
          var geom = sketch.getGeometry();
          if (geom instanceof that.$olmap.geom.Polygon) {
            helpMsg = continuePolygonMsg; //绘制多边形时提示相应内容
          } else if (geom instanceof that.$olmap.geom.LineString) {
            helpMsg = continueLineMsg; //绘制线时提示相应内容
          }
        }
        that.olmap.zxHelpTooltipElement.innerHTML = helpMsg; //将提示信息设置到对话框中显示
        that.olmap.zxHelpTooltip.setPosition(evt.coordinate); //设置帮助提示框的位置
        $(that.olmap.zxHelpTooltipElement).removeClass('hidden'); //移除帮助提示框的隐藏样式进行显示
      }
    },
    //绘图工具 -绘制面
    /**
     * @description 绘图工具 -绘制面
     */
    drawtool() {
      //先清除之前绘制结果
      this.clearMap(this.olmap);
      if (this.olmap.zxDraw) this.olmap.removeInteraction(this.olmap.zxDraw);
      this.olmap.zxDrawLayer.getSource().clear();
      //定义绘制交互工具
      this.olmap.zxDraw = new this.$olmap.interaction.Draw({
        type: 'Polygon',
        source: this.olmap.zxDrawLayer.getSource(),
        style: new this.$olmap.style.Style({
          //绘制几何图形的样式
          fill: new this.$olmap.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new this.$olmap.style.Stroke({
            color: 'rgba(255, 0, 0, 0.5)',
            width: 2,
          }),
          image: new this.$olmap.style.Circle({
            radius: 4,
            stroke: new this.$olmap.style.Stroke({
              color: 'rgba(255, 0, 0, 0.7)',
            }),
            fill: new this.$olmap.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)',
            }),
          }),
        }),
      });
      let that = this;
      this.olmap.addInteraction(this.olmap.zxDraw);
      this.olmap.zxDraw.on('drawstart', function(evt) {});
      //绑定交互绘制工具结束绘制的事件
      this.olmap.zxDraw.on('drawend', function(evt) {
        //currentGeom = evt.feature.getGeometry();
        that.olmap.removeInteraction(that.olmap.zxDraw);
      });
    },
    //修改全屏状态
    screenState() {
      // if (this.isFullScreen) {
      //   this.toolType['1'] = 'unfullScreen';
      //   let item = this.toolsData.find(n => n.id == '1');
      //   item.title = '取消全屏';
      //   item.img = '../../../static/maptool/UnFullScreen.png';
      // } else {
      // this.toolType['1'] = 'fullScreen';
      // let item = this.toolsData.find(n => n.id == '1');
      // item.title = '全屏';
      // item.img = '../../../static/maptool/FullScreen.png';
      //}
    },
    //全屏
    fullScreen(item) {
      this.toolType['1'] = 'unfullScreen';
      // item.title = '取消全屏';
      // item.img = '../../../static/maptool/UnFullScreen.png';
      let elem = document.getElementById('olmapdiv');
      if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
      } else {
        if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else {
          if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
          } else {
            if (elem.requestFullScreen) {
              elem.requestFullscreen();
            } else {
              var wsh = new ActiveXObject('WScript.Shell');
              wsh.sendKeys('{F11}');
            }
          }
        }
      }
    },
    //取消全屏
    unfullScreen(item) {
      item.name = '全屏';
      this.toolType['1'] = 'fullScreen';
      item.img = '../../../static/maptool/FullScreen.png';
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else {
        var wsh = new ActiveXObject('WScript.Shell');
        wsh.sendKeys('{F11}');
      }
    },
    //全图
    full(item) {
      var MyComponent = Vue.component('MapItem');
      citycenter.setView(
        new this.$olmap.View({
          // center: this.$olmap.proj.transform(config.map.center, 'EPSG:4326', 'EPSG:3857'),
          center: appConfig.map.center,
          zoom:
            this.$route.name == 'CityDetail' || this.$route.name == 'TouristResources'
              ? 9
              : appConfig.map.zoom,
        })
      );
    },
    //放大
    zoomOut(item) {
      var MyComponent = Vue.component('MapItem');
      let view = this.olmap.getView();
      let zoom = view.getZoom();
      view.setZoom(zoom + 1);
    },
    //缩小
    zoomIn(item) {
      var MyComponent = Vue.component('MapItem');
      let view = this.olmap.getView();
      let zoom = view.getZoom();
      view.setZoom(zoom - 1);
    },
    //定位
    location(item) {},

    // 数据导入 2020 12-7 zt
    handleUpload1(file) {
      // 文件上传之前的钩子

      if (!this.uploadData.layerName && this.uploadData.saveLayer == 'true') {
        this.$Message.info('图层名称不能为空');
        return false;
      }
      this.spinshow = true;
      // 获取用户登录
      this.uploadData.username = this.userinfo.username ? this.userinfo.username : '';
    },
    // 数据导入 2020 12-7 zt
    handleFormatError2(file) {
      this.spinshow = false;
      this.$Message.info('文件格式不正确,请重新选择');
      this.$refs.dwgUpload.clearFiles();
    },
    // 重置导入图层的表单
    resetForm() {
      this.uploadData.saveLayer = 'true';
      this.uploadData.layerName = '';
      this.uploadData.description = '';
      this.uploadData.type = 'dwg';
      this.uploadData.inputCoordinate = 'EPSG:4490';
    },
    // 数据导入 2020 12-7 zt  dwg上传
    uploadSuccess23(res, file) {
      // 直接拿返回结果然后调用那个绘制图层的
      if (res.code == 200 && res.message == 'success') {
        let geojson = res.result.message;
        this.drawshpanddwg(geojson);
        // debugger;
        if (this.uploadData.saveLayer == 'true') {
          // 发送请求
          // 获取用户登录
          this.uploadData.username = this.userinfo.username ? this.userinfo.username : '';
          let param = {
            layerName: this.uploadData.layerName,
            description: this.uploadData.description,
            type: this.uploadData.type,
            saveLayer: true,
            username: this.uploadData.username,
            geometry: geojson,
          };
          var shpResult = shpUpload(param);
          this.getMyLayer();
          this.resetForm();
          this.$refs.dwgUpload.clearFiles();
          this.uploadModal = false;
        } else {
          this.$Message.success('上传dwg成功');
          this.$refs.dwgUpload.clearFiles();
          this.uploadModal = false;
          this.resetForm();
        }
      } else {
        this.$Message.warning('上传文件失败');
        this.resetForm();
        this.uploadModal = false;
        this.$refs.dwgUpload.clearFiles();
      }
    },
    // shp数据导入成功的函数  shp
    uploadSuccessShp(res, file) {
      // console.log('shp', res);
      this.resetForm();
      this.$refs.shpUpload.clearFiles();
      this.uploadModal = false;
    },
    // 图层查询
    getMyLayer() {
      // 查询图层
      var that = this;
      var param = {
        pageSize: 50,
        pageNumber: 1,
      };
      $.ajax({
        type: 'GET',
        data: param,
        url: this.xbootConfig + '/shpAddFeature/getByCondition',
        dataType: 'json', //预期服务器返回数据的类型
        headers: {
          accessToken: Cookies.get('accessToken'),
        },
        success: function(data) {
          // 获取数据，保存到图层树
          if (data.code == 200 && data.result && data.result.content.length > 0) {
            var mylayer = {
              id: 'mylayer123',
              title: '我的图层',
              type: 'dir',
              expand: 'true',
              visible: true,
              disabled: true,
              children: [],
            };
            for (var i = 0; i < data.result.content.length; i++) {
              var xx = data.result.content[i];
              var itmlayer = {
                id: xx.id,
                title: xx.layerName,
                type: 'polygon',
                icon: 'polygon',
                expand: 'true',
                contextmenu: true,
                features: xx.geometry,
                pname: '我的图层',
              };
              mylayer.children.push(itmlayer);
            }
            that.$bus.emit('getallLayer', mylayer); //发送数据
            // if(that.olmap.allLayerData[that.olmap.allLayerData.length-1].title == '我的图层'){
            //   that.olmap.allLayerData[that.olmap.allLayerData.length-1] = that.layersData;
            // }else{
            //   that.olmap.allLayerData.push(that.layersData);
            // }
          }
        },
      });
    },
    // 数据导入 2020 12-7 zt
    uploadError(error, file) {
      //上传失败
      this.$Message.info(error);
    },
    closemodel() {
      this.uploadModal = false;
      this.uploadData.layerName = '';
      this.uploadData.username = '';
      this.uploadData.description = '';
    },
    // 绘制导入的shp和dwg图层 zt 20201208
    drawshpanddwg(data, id) {
      /**
       *
       * // 绘制图层
       * data-geojson格式
       * */
      if (!id) {
        id = 'query_shpdwg';
      }
      //  先移除图层
      var arr = [];
      var layers = this.olmap.getLayers();
      layers.forEach(function(sublayer, i) {
        if (sublayer.getProperties().id == id) arr.push(sublayer);
      });
      for (var i = 0; i < arr.length; i++) {
        this.olmap.removeLayer(arr[i]);
      }

      var layerStyle = new this.$olmap.style.Style({
        fill: new this.$olmap.style.Fill({
          color: 'rgba(255, 255, 255, 0.5)', //填充颜色
        }),
        stroke: new ol.style.Stroke({
          color: '#008000', //边框颜色
          width: 2, // 边框宽度
        }),
        image: new ol.style.Circle({
          radius: 1,
          fill: new ol.style.Fill({
            color: '#008000',
          }),
        }),
        text: new this.$olmap.style.Text({
          textBaseline: 'middle',
          rotateWithView: true,
          font: '10px Microsoft YaHei',
        }),
      });
      this.shpdwgDrawLayer = new this.$olmap.layer.Vector({
        id: id,
        zIndex: 1002,
        source: new this.$olmap.source.Vector(),
        style: function(feature) {
          let text = '';
          if (feature.values_ && feature.values_.TxtMemo) {
            text = feature.values_.TxtMemo;

            if (text != '') {
              layerStyle.getText().setText(text);
            }
          }

          //if(info)layerStyle.setFill(new ol.style.Fill({color:info.fill_color}));
          return layerStyle;
        },
        // style: new this.$olmap.style.Style({ //图层样式
        //   fill: new this.$olmap.style.Fill({
        //     color: 'rgba(255, 255, 255, 0.5)' //填充颜色
        //   }),
        //   stroke: new ol.style.Stroke({
        //     color: "#008000", //边框颜色
        //     width: 2 // 边框宽度
        //   }),     //形状
        //   image: new ol.style.Circle({
        //     radius: 5,
        //     fill: new ol.style.Fill({
        //       color: '#008000'
        //     })
        //   })
        // })
      });
      this.shpdwgDrawLayer.set('zIndex', 30003);
      this.olmap.addLayer(this.shpdwgDrawLayer);
      //清除所有数据源
      var markersour = this.shpdwgDrawLayer.getSource();
      markersour.clear();
      // 判断类型
      if (this.uploadData.type == 'shp') {
        // 判断返回格式是否是geojson
        var geojson_format = new this.$olmap.format.GeoJSON();
        var features = geojson_format.readFeatures(data);
      } else {
        var geojson_format = new this.$olmap.format.GeoJSON();
        //空间参考转换
        var features = geojson_format.readFeatures(data);
      }
      markersour.addFeatures(features);

      // 定位
      this.olmap.getView().fit(markersour.getExtent());
    },
    // 上传文件 shpzip文件进行解析
    shpBeforupload22(file) {
      const self = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = function() {
        // eslint-disable-next-line no-undef
        shp(this.result).then(
          geojson => {
            if (geojson.features && geojson.features.length === 0) {
              self.$message.warning('数据存在问题，请重新上传！');
              self.deleteShp();
            } else if (geojson.features.length > 1) {
              self.$message.warning('数据是多面对象，请重新上传！');
              self.deleteShp();
            }
          },
          error => {
            self.deleteShp();
            self.$message.warning('上传文件不正确');
          }
        );
      };
      reader.onerror = function(event) {
        self.$message.warning('上传失败');
        reader.abort();
        self.deleteShp();
      };
    },
    //shp上传
    shpBeforupload(file) {
      if (!this.uploadData.layerName && this.uploadData.saveLayer == 'true') {
        this.$Message.info('图层名称不能为空');
        return false;
      }
      if (file.name.indexOf('.shp') == -1) {
        this.$Message.info('请上传shp文件');
      } else {
        this.readShpFile(file);
      }
      // return false;
    },
    // 解析shp的方法
    readShpFile(shpFile) {
      // debugger;
      var that = this;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(shpFile);
      fileReader.onload = function() {
        let shapefile = require('shapefile');
        shapefile.read(this.result).then(geoJson => {
          // 发送请求
          // var geojson_format = new that.$olmap.format.GeoJSON();
          // var shpfeatures = geojson_format.readFeatures(geoJson);
          that.drawshpanddwg(geoJson);
          // 判断图层是否保存
          // debugger;
          if (that.uploadData.saveLayer == 'true') {
            // 发送请求
            // 获取用户登录
            that.uploadData.username = that.userinfo.username ? that.userinfo.username : '';
            let param = {
              layerName: that.uploadData.layerName,
              description: that.uploadData.description,
              type: that.uploadData.type,
              saveLayer: true,
              username: that.uploadData.username,
              geometry: JSON.stringify(geoJson),
            };
            // console.log(2222222222,param.geometry);
            var shpResult = shpUpload(param);
            // debugger;
            if (shpResult.code == 200) {
              // debugger;
              that.$Message.info('上传成功');
              that.uploadModal = false;
              that.uploadData.layerName = '';
              that.uploadData.username = '';
              that.uploadData.description = '';
              // 查询图层
              that.getMyLayer();
              that.resetForm();
              // that.$refs.shpUpload.clearFiles();
              that.uploadModal = false;
              // console.log(333333);
            } else {
              that.$Message.info('上传失败');
              that.resetForm();
              // that.$refs.shpUpload.clearFiles();
              that.uploadModal = false;
              that.getMyLayer();
              // console.log(9999);
            }
          } else {
            // 上传shp但是不保存到图层目录树里面的时候
            that.resetForm();
            // that.$refs.shpUpload.clearFiles();
            that.uploadModal = false;
            that.getMyLayer();
          }
        });
      };
    },
    // txt文件
    txtBeforupload(file) {
      if (file.type == 'text/plain') {
        var that = this;
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function(oFREvent) {
          //读取完毕从中取值
          var pointsTxt = oFREvent.target.result;
          console.log(pointsTxt);
          if (pointsTxt) {
            let result = that.publicMethod.selectTextFile(pointsTxt); //通用txt封装方法
            if (!result) {
              that.$Message.info('该数据格式不正确，不支持解析!');
              return;
            }
            result.currentGeometryType = that.currentGeometryType;
            if (result.inputPolygons && result.inputPolygons.length > 0) {
              that.initSource(null, result.inputPolygons, result.typeCode);
            } else {
              that.$Message.warning({
                content: 'txt的坐标文件不正确',
              });
            }
          } else {
            that.$Message.warning({
              content: 'txt的坐标文件不正确',
            });
          }
          // } else {
          // }
        };
      } else {
        this.$Message.info('请上传txt文件');
      }
      // return false;
    },
    initSource(features, geomtry, typeCode) {
      var datasource;
      if (features) {
        //根据上传shp绘制
        datasource = new this.$olmap.source.Vector({
          features: features,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      if (geomtry) {
        //根据上传txt坐标点
        var featuresList = [];
        this.drawGrid.polygonJson = [];
        this.drawGrid.polygonWKT = [];
        for (var item in geomtry) {
          //上传txt存在多面
          var PolygonFeature = new this.$olmap.Feature({
            geometry: geomtry[item],
          });
          console.log(geomtry[item].getCoordinates()[0][0]);
          if (typeCode == 'bzb') {
            this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          } else {
            geomtry[item].getCoordinates()[0].forEach(geo => {
              this.drawGrid.polygonJson.push(geo);
            });
          }
          // this.drawGrid.polygonJson.push(geomtry[item].getCoordinates()[0][0]);
          featuresList.push(PolygonFeature);
          this.drawGrid.polygonWKT.push(
            new this.$olmap.format.WKT().writeGeometry(PolygonFeature.getGeometry(), {})
          ); // geoserver方式
        }
        this.drawGrid.geometry = geomtry[0];
        datasource = new this.$olmap.source.Vector({
          features: featuresList,
        });
        this.olmap.getView().fit(datasource.getExtent());
      }
      this.initDraw('Polygon', datasource);
    },
    initDraw(type, datasource) {
      //实例化一个矢量图层Vector作为绘制层
      if (this.gridDraws) {
        this.olmap.removeInteraction(this.gridDraws);
        this.gridDrawLayer.getSource().clear();
      }
      var result = this.publicMethod.initDrawC(type, datasource); //通用封装方法
      // console.log('ssssss', result);
      this.gridDraws = result.gridDraws;
      this.gridDrawLayer = result.gridDrawLayer;
      this.olmap.addLayer(this.gridDrawLayer);
    },

    uploadTxtSuccess() {
      this.$Message.success('txt上传成功');
      this.resetForm();
      this.uploadModal = false;
      if (this.uploadData.saveLayer == 'true') {
        this.getMyLayer();
      }
      this.$refs.txtUpload.clearFiles();
    },
    uploadTxtError() {
      this.resetForm();
      this.uploadModal = false;
      this.$refs.txtUpload.clearFiles();
    },
    // 下载示例文件
    handleDownload() {
      window.location.href = window.g.downloadExample;
      console.log('点击下载示例文件');
    },
    // 取消按钮绑定的函数
    cancelSub() {
      this.resetForm();
      this.uploadModal = false;
      this.$refs.txtUpload.clearFiles();
      this.$refs.shpUpload.clearFiles();
      this.$refs.dwgUpload.clearFiles();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/maptools/MapTools.js